import { IconButton, Icon } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";

interface IErrorSnackbarProps {
    message: string | null;
    open: boolean;
    onClose: () => void;
}

function ErrorSnackbar(props: IErrorSnackbarProps) {
    return (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left"
            }}
            open={props.open}
            autoHideDuration={6000}
            onClose={props.onClose}
        >
            <SnackbarContent
                className="errorSnackbar"
                message={
                    <span id="message-id" className="snackbarMessage">
                        <Icon className="snackbarIcon">
                            error
                        </Icon>
                        {props.message}
                    </span>
                }
                action={[
                    <IconButton
                        key="close"
                        aria-label="close"
                        color="inherit"
                        onClick={props.onClose}
                    >
                        <Icon>
                            cancel
                        </Icon>
                    </IconButton>
                ]}
            />
        </Snackbar>
    );
}

export default ErrorSnackbar;
